"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBasketAvailableWidth = void 0;
const react_1 = require("react");
const useBasketAvailableWidth = (inputValue, basketInputWidthWithoutEmptySpace) => {
    const [maxBetBlockWidth, setMaxBetBlockWidth] = (0, react_1.useState)(0);
    const [inputWinSumWidth, setInputWinSumWidth] = (0, react_1.useState)(0);
    const measuredRef = (0, react_1.useCallback)((node) => {
        if (node !== null) {
            setInputWinSumWidth(() => node.clientWidth);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [inputValue]);
    // here we count the width of the blocks and if they exceed the width of the input,
    // then we show the hint instead of the full line of the min and max bet
    const isShownHint = (0, react_1.useMemo)(() => maxBetBlockWidth + inputWinSumWidth > basketInputWidthWithoutEmptySpace, [maxBetBlockWidth, inputWinSumWidth, basketInputWidthWithoutEmptySpace]);
    return [isShownHint, setMaxBetBlockWidth, measuredRef];
};
exports.useBasketAvailableWidth = useBasketAvailableWidth;
//# sourceMappingURL=useBasketAvailableWidth.js.map